import { NielsenEventMetadata, NielsenEventTag, NielsenEventValue, NielsenGateway } from '../types';

export class AggregateNielsenGateway implements NielsenGateway {
  #instances;

  constructor(instances: NielsenGateway[]) {
    this.#instances = instances;
  }

  send(tag: NielsenEventTag, value: NielsenEventValue, metadata: NielsenEventMetadata): void {
    const exceptions: any[] = [];

    this.#instances.forEach(instance => {
      try {
        instance.send(tag, value, metadata);
      } catch (e: any) {
        exceptions.push(e);
      }
    });

    if (exceptions.length > 0) {
      const combinedMessages = exceptions.map(e => {
        if (e instanceof Error) {
          return e.message;
        }
        if ('toString' in e) {
          return e.toString();
        }

        return JSON.stringify(e);
      });

      throw new Error(
        `AggregateNielsenGateway: ${exceptions.length} exceptions occurred.\n${combinedMessages}`
      );
    }
  }
}
